import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, MapPin, Package, Users } from 'lucide-react';
import PublicNavbar from '../../components/public/navbar/PublicNavbar';
import PublicFooter from '../../components/public/footer/PublicFooter';
import SEO from '../../components/shared/SEO';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <SEO
        title="Page Not Found"
        description="The page you're looking for doesn't exist. Browse our filming locations, equipment rentals, and talent services in Chicago."
        url="/404"
      />
      <PublicNavbar />

      <div className="not-found-content">
        <div className="container">
          <div className="not-found-hero">
            <span className="not-found-code">404</span>
            <h1 className="not-found-title">Scene Not Found</h1>
            <p className="not-found-text">
              Looks like this shot didn't make the final cut. The page you're looking for
              doesn't exist or has been moved.
            </p>

            <div className="not-found-actions">
              <Link to="/" className="btn btn-primary">
                <Home size={18} />
                Back to Home
              </Link>
              <button onClick={() => window.history.back()} className="btn btn-ghost">
                <ArrowLeft size={18} />
                Go Back
              </button>
            </div>
          </div>

          <div className="not-found-suggestions">
            <h2 className="suggestions-title">Explore Our Services</h2>
            <div className="suggestions-grid">
              <Link to="/locations" className="suggestion-card">
                <MapPin size={32} />
                <h3>Locations</h3>
                <p>Find the perfect filming location</p>
              </Link>
              <Link to="/equipment" className="suggestion-card">
                <Package size={32} />
                <h3>Equipment</h3>
                <p>Rent professional gear</p>
              </Link>
              <Link to="/talent" className="suggestion-card">
                <Users size={32} />
                <h3>Talent</h3>
                <p>Hire experienced crew</p>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default NotFound;
